import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BooleanInput } from '@shared/decorators/boolean-input.decorator';

export type AnnouncementBannerVariant = 'info' | 'warning' | 'danger' | 'success';

/**
 * Presentational dark-theme system banner. Bevat geen data-koppeling: alle
 * properties komen via inputs. Wordt gebruikt door {@link PAnnouncementComponent}
 * (smart wrapper rond live Announcement-data) én rechtstreeks in de
 * styleguide om alle varianten te tonen.
 */
@Component({
  selector: 'p-announcement-banner',
  templateUrl: './p-announcement-banner.component.html',
  styleUrls: ['./p-announcement-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PAnnouncementBannerComponent {
  @Input() variant: AnnouncementBannerVariant = 'info';
  @Input() icon = 'info-circle';
  @Input() title?: string;
  @Input() message?: string;

  /** Toon sluit-knop rechts; default `true`. */
  @BooleanInput() @Input() closable = true;

  @Output() readonly closed = new EventEmitter<void>();

  protected isHidden = false;

  protected close(): void {
    this.isHidden = true;
    this.closed.emit();
  }
}
